import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserService } from '@frontend/sports/user/feature';

import { BetslipPick } from '../../../../core/picks/betslip-pick';
import { ITeaserBetPickState, ITeaserBetState } from '../../state';

@Component({
    selector: 'bs-teaser-bet',
    templateUrl: './teaser-bet.component.html',
    styleUrls: ['./teaser-bet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TeaserBetComponent implements OnChanges {
    @HostBinding('class.bs-teaser-bet-disabled') disabled = false;

    @Input() teaserBetState: ITeaserBetState;
    @Input() pickList: BetslipPick[] = [];
    @Input() oddsDisplayFormat: OddsDisplayFormat;

    shouldShowTeaserLogo = false;

    teaserPickList: BetslipPick[] = [];

    teaserTitle: string | undefined;
    leagueId: number | undefined;

    constructor(public m2User: UserService) {}

    ngOnChanges(changes: ISimpleChanges<TeaserBetComponent>): void {
        if (!changes.pickList && !changes.teaserBetState) {
            return;
        }
        this.teaserPickList = this.pickList.filter((pick) => Object.keys(this.teaserBetState.picks).includes(pick.id.toString())) || [];
    }

    getPickState(pick: BetslipPick): ITeaserBetPickState | undefined {
        return this.teaserBetState.picks[pick.id.toString()];
    }
}
